import { Suspense, type ReactNode } from 'react';
import { PageSkeleton } from '@/shared/components/PageSkeleton';

type RouteSuspenseProps = {
  children: ReactNode;
};

/** Suspense boundary for lazy-loaded route segments. */
export function RouteSuspense({ children }: RouteSuspenseProps) {
  return (
    <Suspense fallback={<PageSkeleton variant="page" className="p-6" />}>
      {children}
    </Suspense>
  );
}
